export default __webpack_public_path__ + "static/tooltip-anatomy-dark-99725c9db37af86362eccee20be438af9289231f8c23ca6a064133dafe435f9a.png";